
import { __ } from 'bits/intl'
import { Component, Vue } from 'bits/vue'
import AccessibilityDropdown from 'library/v4/components/accessibility-dropdown.vue'
import Dropdown from 'library/v4/components/dropdown.vue'
import BaseIcon from 'vuecomponents/base_icon.vue'
import LocaleSelector from 'vuecomponents/locale_selector.vue'

@Component({
  components: {
    BaseIcon,
    LocaleSelector,
    Dropdown,
    AccessibilityDropdown,
  },
})
export default class SidebarFooter extends Vue {
  moreServices = {
    product: {
      header: __('Product'),
      links: [
        {
          title: __('Features,'),
          link: '/features',
        },
        {
          title: __('Apps and plugins,'),
          link: '/about/apps',
        },
        {
          title: __("What's new"),
          link: 'https://padlet.blog',
        },
      ],
    },
    membership: {
      header: __('Memberships'),
      links: [
        {
          title: __('Personal,'),
          link: '/memberships',
        },
        {
          title: __('Business,'),
          link: '/memberships',
        },
        {
          title: __('Schools'),
          link: '/memberships',
        },
      ],
    },
    company: {
      header: __('Company'),
      links: [
        {
          title: __('Company,'),
          link: '/about/us',
        },
        {
          title: __('Jobs,'),
          link: 'https://padlet.jobs',
        },
        {
          title: __('Twitter'),
          link: 'https://twitter.com/padlet',
        },
      ],
    },
    support: {
      header: __('Support'),
      links: [
        {
          title: __('Knowledge base,'),
          link: 'https://padlet.help',
        },
        {
          title: __('Video tutorials,'),
          link: 'https://www.youtube.com/padlet',
        },
        {
          title: __('Examples,'),
          link: '/gallery',
        },
        {
          title: __('Email'),
          link: '/contact-us',
        },
      ],
    },
    legal: {
      header: __('Legal'),
      links: [
        {
          title: __('Terms of use,'),
          link: '/about/terms',
        },
        {
          title: __('Privacy policy,'),
          link: '/about/privacy',
        },
        {
          title: __('Content policy,'),
          link: '/about/content',
        },
        {
          title: __('Accessibility statement'),
          link: '/about/accessibility',
        },
      ],
    },
  }
}
